import { mapActions } from 'vuex';

import ResponseUtil from '@/util/response-util';

import clockTimeEntry from '@/mixins/clocking/clockTimeEntry';

export default {
  mixins: [clockTimeEntry],

  methods: {
    ...mapActions(['saveShiftTimeEntry']),

    postShiftTimeEntry(unsavedTimeEntry, successCallBack, lastly, isCloningTimePair = false) {
      this.saveShiftTimeEntry(unsavedTimeEntry)
      .then((response) => successCallBack(response.data, isCloningTimePair))
      .catch((error) => {
        this.showAppErrorDialog({
          message: ResponseUtil.getTimeRequestErrorMessage(error.response),
        });
      })
      .finally(() => lastly());
    },
  },
};
